import { useReadOnly } from "@/components/SupportView";

// TES-1306 — the patient's backup number beside the call.
//
// Emelie, 2026-10-13: "När ett reservnummer finns ska Kirill se det i
// möteskortet och mötesdetaljerna, nära länken till det digitala mötet, med
// etiketten: Reservnummer vid tekniska problem". With none: "Om inget nummer
// har lämnats visas diskret Inget reservnummer lämnat" — no error, nothing
// to do.
//
// `undefined` means the server did not send the field: an admin's support
// read (the number is the treating doctor's only) or an older API. Then
// nothing renders, neither the number nor the placeholder; the read-only
// check is belt and braces for the same rule.
export function BackupPhoneLine({
  backupPhone,
  tone = "light",
}: {
  backupPhone: string | null | undefined;
  // "dark" on the video card's dark background.
  tone?: "light" | "dark";
}) {
  const readOnly = useReadOnly();
  if (backupPhone === undefined || readOnly) return null;
  const muted = tone === "dark" ? "text-white/70" : "text-textSecondary";
  if (backupPhone === null) {
    return <p className={`text-sm ${muted}`}>Inget reservnummer lämnat</p>;
  }
  return (
    <p className={`text-sm ${muted}`}>
      Reservnummer vid tekniska problem:{" "}
      <a
        href={`tel:${backupPhone}`}
        className={`font-semibold underline underline-offset-2 ${
          tone === "dark" ? "text-white" : "text-textPrimary"
        }`}
      >
        {backupPhone}
      </a>
    </p>
  );
}
